function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.307,11.468H2.693c-0.294,0-0.532,0.238-0.532,0.532s0.238,0.532,0.532,0.532h18.614c0.294,0,0.532-0.238,0.532-0.532  S21.601,11.468,21.307,11.468z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M21.307,16.787H2.693c-0.294,0-0.532,0.238-0.532,0.532s0.238,0.532,0.532,0.532h18.614c0.294,0,0.532-0.238,0.532-0.532  S21.601,16.787,21.307,16.787z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M2.693,7.214h18.614c0.294,0,0.532-0.238,0.532-0.532S21.601,6.15,21.307,6.15H2.693c-0.294,0-0.532,0.238-0.532,0.532  S2.399,7.214,2.693,7.214z"
});

var SvgMenuIcon = function SvgMenuIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 30",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMenuIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/menuIcon.0e2b3cbc.svg";
export { ForwardRef as ReactComponent };